import api from "./api";
import { useAuth } from "./auth";
import { Switch } from "../components/ui/switch";

// Per-Admin UI preference saved on the Admin's own account (users.ui_prefs).
export function useAdminPref(key) {
  const { user, setUser } = useAuth();
  const value = !!user?.ui_prefs?.[key];
  const set = async (v) => {
    setUser((u) => (u ? { ...u, ui_prefs: { ...(u.ui_prefs || {}), [key]: v } } : u));
    try {
      const { data } = await api.put("/admin/ui-prefs", { [key]: v });
      setUser((u) => (u ? { ...u, ui_prefs: data } : u));
    } catch (_) { /* keep local choice; next load reflects the server */ }
  };
  return [value, set];
}

export function ActiveOnlySwitch({ checked, onChange, testId }) {
  return (
    <label className="flex items-center gap-2 text-xs font-medium text-zinc-600 cursor-pointer select-none">
      <Switch checked={checked} onCheckedChange={onChange} data-testid={testId} />
      Active Only
    </label>
  );
}
